var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAuthApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.66923 2.41474C10.4281 1.48156 11.7303 0.764937 12.8444 0.6875C13.0311 1.96324 12.5152 3.21273 11.8334 4.09604C11.1046 5.04497 9.84686 5.77865 8.62957 5.74059C8.40753 4.51866 8.97699 3.26129 9.66923 2.41474ZM13.2545 5.60278C14.6742 5.60278 16.1775 6.38502 17.2472 7.73295C13.7403 9.67675 14.3085 14.7403 17.852 16.0961C17.3648 17.1881 17.131 17.6751 16.5028 18.6424C15.6264 19.9916 14.3921 21.6729 12.86 21.6847C12.2303 21.6914 11.8171 21.4999 11.3716 21.2933C10.8553 21.054 10.2955 20.7945 9.30482 20.8001C8.31956 20.805 7.75085 21.0613 7.22746 21.2972C6.77048 21.5031 6.34804 21.6935 5.71305 21.6874C4.18229 21.6742 3.01203 20.157 2.13563 18.8078C-0.313307 15.037 -0.571915 10.6099 0.939244 8.25532C2.01417 6.58321 3.70949 5.6054 5.30162 5.6054C6.15018 5.6054 6.83408 5.85181 7.4858 6.08663C8.07896 6.30035 8.64548 6.50446 9.28523 6.50446C9.87721 6.50446 10.3639 6.31811 10.8948 6.11485C11.5317 5.87099 12.2323 5.60278 13.2545 5.60278Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAuthApple);
export default __webpack_public_path__ + "static/media/ic_auth_apple.5f0466cc90d58cb4e6f0012f66fbc648.svg";
export { ForwardRef as ReactComponent };